<template>
    <div v-if="claim.visuals" :class="customiseClass ? customiseClass : 'pb-1'">
        <div
            v-for="(visual, index) in claim.visuals"
            :key="visual.id"
            class="border-bleu"
            :class="isBlack ? 'bg-gray1' : 'bg-gray2'"
        >
            <div class="col-12 px-0 visual-claim-border">
                <div class="d-flex align-items-center claim-padding">
                    <div
                        :key="visual.id"
                        class="image-wrapper d-flex justify-content-center align-items-center pe-1"
                    >
                        <img
                            loading="lazy"
                            :src="visual.url"
                            :alt="visual.alt"
                            class="visual-claim-img"
                            aria-hidden="true"
                        >
                    </div>
                    <div class="text-wrapper">
                        <span v-msh-html="claim.attributes[index] ? claim.attributes[index].textHtml : ''" class="small" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else :class="customiseClass ? customiseClass : 'pb-1'">
        <div
            class="border-bleu"
            :class="isBlack ? 'bg-gray1' : 'bg-gray2'"
        >
            <template v-for="(attribute, index) in claim.attributes">
                <div :key="index" class="d-flex align-items-center justify-content-start">
                    <span v-msh-html="attribute.textHtml" class="small claim-padding" />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "OfferClaim",
    props: {
        claim: {
            type: Object,
            required: true
        },
        isBlack: {
            type: Boolean,
            required: false,
            default: false
        },
        customiseClass:{
            type: String,
            required: false,
            default: null
        }
    }
}
</script>

<style lang="scss" scoped>

.margin-bottom-7 {
    margin-bottom: 7px;
}

.margin-bottom-10 {
    margin-bottom: 10px;
}

.claim-padding {
    display: grid;
    padding: 7px 7px 7px 7px;
}

.visual-claim-img {
    max-width: 60px;
    max-height: 36px;
}

.border-bleu {
    border-left: 5px solid #26B2FF
}

.image-wrapper {
    flex: 0 0 auto;
    width: 30%;
    max-width: 80px;
    min-width: 36px;
    min-height: 36px;
}

.image-wrapper img {
    height: auto;
    display: block;
}

.text-wrapper {
    flex: 1;
    overflow-wrap: break-word;
}

</style>
